import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ProductErrorProps {
  title?: string;
  message?: string;
}

export function ProductError({ 
  title = "Error", 
  message = "Failed to load product details." 
}: ProductErrorProps) {
  return (
    <div className="container mx-auto p-6">
      <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-red-500">{title}</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-slate-600">{message}</p>
        </CardContent>
      </Card>
    </div>
  );
}